import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import { ValueCell } from "@tools";

export const PriceModifierCompanyCostCell = observer((cellProps) => {
  
  return <ValueCell
    colName={ SummaryColumns.C_COST }
    useDynamicWidth
    {...cellProps}
  />
})